<p *ngIf="bool">
    history works!
</p>
